import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { styled, Menu, MenuItem } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { IconButton } from '@ds/react-components';
import { ReactComponent as ProfileSvg } from 'assets/img-profile-placeholder-S.svg';

const ProfileMenuContainer = styled('div')(({ menuopen }) => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  paddingRight: menuopen ? '17px' : '0px', //Fix for disappearing scroll bar
}));

const ProfileName = styled('p')({
  fontSize: '14px',
  margin: '0 0 0 10px',
});

const ProfileMenu = styled(Menu)(({ theme }) => ({
  color: theme.palette.common.black,
}));

const ProfileMenuItem = styled(MenuItem)(({ theme, line }) => ({
  color: theme.palette.common.black,
  borderBottom: line ? `1px solid ${theme.palette.common.athensGray} ` : 'none',
}));

const Profile = (props) => {
  const { profileName, profileMenuEntries } = props;

  const [anchorEl, setAnchorEl] = useState(null);

  const handleProfileMenuOpen = useCallback(
    (event) => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl]
  );

  const handleProfileMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  return (
    <>
      <ProfileMenuContainer
        menuopen={anchorEl ? 'true' : ''}
        onClick={handleProfileMenuOpen}
        aria-owns={anchorEl ? 'material-appbar' : undefined}>
        <IconButton aria-haspopup="true" variant={'none'}>
          <ProfileSvg />
        </IconButton>
        <ProfileName>{profileName}</ProfileName>
      </ProfileMenuContainer>
      <ProfileMenu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={!!anchorEl}
        getContentAnchorEl={null}
        onClose={handleProfileMenuClose}>
        {profileMenuEntries.map((item, index) => {
          return (
            <Link
              key={item.name}
              to={item.path}
              onClick={handleProfileMenuClose}>
              <ProfileMenuItem
                key={item.name}
                line={index % 2 === 1 ? 'true' : ''}>
                {item.name}
              </ProfileMenuItem>
            </Link>
          );
        })}
      </ProfileMenu>
    </>
  );
};

Profile.propTypes = {
  classes: PropTypes.object.isRequired,
  profileName: PropTypes.string.isRequired,
  profileMenuEntries: PropTypes.array.isRequired,
};

export default Profile;
